import { render, staticRenderFns } from "./AdditionalDataRoom.vue?vue&type=template&id=60ab1e51&scoped=true&"
import script from "./AdditionalDataRoom.vue?vue&type=script&lang=js&"
export * from "./AdditionalDataRoom.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalDataRoom.vue?vue&type=style&index=0&id=60ab1e51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ab1e51",
  null
  
)

export default component.exports